// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"584":"f65be896","614":"64250497","876":"074a948a"}[chunkId] + ".chunk.css";
};